function getScrollTarget(hash) {
  if (!hash || hash === "#") return null;

  try {
    return document.querySelector(hash);
  } catch {
    return null;
  }
}

function getHeaderOffset() {
  const header = document.querySelector("header[data-testid='navbar']") || document.querySelector("header");
  return (header?.getBoundingClientRect().height || 80) + 16;
}

function scrollToHash(hash) {
  const target = getScrollTarget(hash);
  if (!target) return false;

  const targetTop = hash === "#top"
    ? 0
    : Math.max(0, window.scrollY + target.getBoundingClientRect().top - getHeaderOffset());

  window.scrollTo({
    top: targetTop,
    behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
  });

  // Preserve keyboard navigation for skip links targeting a focusable region.
  if (target.hasAttribute("tabindex")) {
    target.focus({ preventScroll: true });
  }

  return true;
}

let cancelPendingHashScroll = () => {};

function onHashNavigation() {
  cancelPendingHashScroll();
  const hash = window.location.hash;
  if (!hash || hash === "#") return;

  let frame;
  let timeout;
  let observer;

  const cleanup = () => {
    cancelAnimationFrame(frame);
    clearTimeout(timeout);
    observer?.disconnect();
  };
  cancelPendingHashScroll = cleanup;

  const scrollWhenReady = () => {
    if (window.location.hash !== hash) {
      cleanup();
      return;
    }
    if (!getScrollTarget(hash) || frame) return;

    // React can mount the destination after the browser's native fragment jump.
    // Wait for its layout and fixed header before applying the offset once.
    frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(() => {
        frame = undefined;
        if (window.location.hash !== hash || scrollToHash(hash)) cleanup();
      });
    });
  };

  observer = new MutationObserver(scrollWhenReady);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  timeout = setTimeout(cleanup, 5000);
  scrollWhenReady();
}

function onAnchorClick(event) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }

  const anchor = event.target.closest?.("a[href^='#']");
  if (!anchor) return;

  const hash = anchor.getAttribute("href");
  if (!hash || !scrollToHash(hash)) return;

  cancelPendingHashScroll();
  event.preventDefault();

  if (window.location.hash !== hash) {
    window.history.pushState(null, "", hash);
  }
}

document.addEventListener("click", onAnchorClick);
window.addEventListener("hashchange", onHashNavigation);
window.addEventListener("pagehide", () => cancelPendingHashScroll());
onHashNavigation();

document.documentElement.dataset.carthySmoothScroll = "enabled";
